module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/valuePropBottomBg-73f5aa152f76e2a08a749185336ba262.png";